import React from "react";
import "./FloatingBanner.scss";
import IconClose from "../../common/icons/IconClose";

const FloatingBanner = ({ message, url, buttonText, type = "", onClose }) => {
  if (!message && !url && !buttonText) return null;

  return (
    <div className={`floating-banner ${type}`}>
      <div className="floating-banner-content">
        {message && <p>{message}</p>}
        {url && buttonText && (
          <a
            href={url}
            className="floating-banner-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            {buttonText}
          </a>
        )}
      </div>
      {onClose && (
        <button
          className="floating-banner-close"
          onClick={onClose}
          aria-label="Fermer la notification"
        >
          <IconClose />
        </button>
      )}
    </div>
  );
};

export default FloatingBanner;
